import * as React from 'react'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { IDevice } from '@getgreenline/homi-shared'
import { ShiftApi, ShiftModels } from '@getgreenline/shifts'
import { Link } from 'react-router'
import { ShiftLine } from './ShiftLine'
import { Button } from 'antd'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  deviceWithShift?: IDeviceWithShift[]
  showMoreShifts: boolean
  devices?: IDevice[]
}

interface IDeviceWithShift extends IDevice {
  shift?: ShiftModels.IBaseShift[]
}

@inject('currentCompanyStore', 'currentUserStore')
export class POSShifts extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      showMoreShifts: false,
    }
  }

  async componentDidMount() {
    await this.getDevices()
    await this.getDevicesAndShifts()
  }

  getLatestShiftByDevice = async (device: IDevice): Promise<ShiftModels.IBaseShift[]> => {
    const company = this.props.currentCompanyStore!.company!
    const shiftWithLimit = await ShiftApi.getShifts(company.id, device.id, { offset: 0, limit: 1 })
    return shiftWithLimit.data
  }

  async getDevices() {
    await this.props.currentCompanyStore!.getDevices()
    const { devices } = this.props.currentCompanyStore!
    this.setState({ devices: devices })
  }

  async getDevicesAndShifts() {
    await this.props.currentCompanyStore!.getDevices()
    const { devices } = this.props.currentCompanyStore!
    const devicesAndShifts: IDeviceWithShift[] = []
    if (devices) {
      const devicesToShow = this.state.showMoreShifts ? devices : devices.slice(0, 5)
      for (const device of devicesToShow) {
        const shift = await this.getLatestShiftByDevice(device)
        const deviceWithShift: IDeviceWithShift = {
          ...device,
          shift: shift,
        }
        devicesAndShifts.push(deviceWithShift)
      }
      this.setState({ deviceWithShift: devicesAndShifts })
    }
  }

  scrollTop() {
    window.scrollTo(0, 0)
  }

  render() {
    const { company } = this.props.currentCompanyStore!
    const { devices, showMoreShifts } = this.state
    return (
      <div>
        <h5 className='text-muted'>Your POS shifts</h5>
        <div className='text-muted'>
          Check your full shift details{' '}
          <Link to={`/company/${company!.id}/dashboard/reports/shifts`}>here</Link>.
        </div>
        <br />
        <div className='table-responsive'>
          <table className='table table-sm'>
            <tbody>
              {devices === undefined && (
                <tr className='text-muted'>
                  <td>No shift details</td>
                </tr>
              )}
              {/* render first 5 shifts */}
              {devices &&
                devices.slice(0, 5).map((device) => {
                  return <ShiftLine device={device} key={device.id} />
                })}
              {/* show more shifts */}
              {devices &&
                showMoreShifts &&
                devices.slice(5).map((device) => {
                  return <ShiftLine device={device} key={device.id} />
                })}
            </tbody>
          </table>
          {
            // show more button (deviceCount && devices) && deviceCount - devices.length > 5
            devices && devices.length > 5 && (
              <Button
                onClick={() => {
                  if (!showMoreShifts) {
                    this.scrollTop()
                  }
                  this.setState({ showMoreShifts: !showMoreShifts })
                }}
              >
                {showMoreShifts ? 'Show less' : 'Show more'}
              </Button>
            )
          }
        </div>
      </div>
    )
  }
}
